import { Configuration, LogLevel } from '@azure/msal-browser';

// Validação das variáveis de ambiente necessárias
const validateEnvVars = () => {
  const requiredVars = [
    'REACT_APP_AZURE_CLIENT_ID',
    'REACT_APP_AZURE_TENANT_ID',
    'REACT_APP_AZURE_AUTHORITY',
  ];

  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    console.error(
      'Azure AD SSO: Variáveis de ambiente obrigatórias não definidas:',
      missingVars
    );
    throw new Error(
      `Variáveis de ambiente obrigatórias não definidas: ${missingVars.join(
        ', '
      )}`
    );
  }
};

// Validar variáveis na inicialização
validateEnvVars();

// Configuração do Azure AD
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: process.env.REACT_APP_AZURE_AUTHORITY || '',
    redirectUri:
      process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI ||
      window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Escopos solicitados (permissões)
export const loginRequest = {
  scopes: ['User.Read', 'profile', 'email', 'openid'],
};

export const graphConfig = {
  graphMeEndpoint:
    process.env.REACT_APP_GRAPH_ME_ENDPOINT ||
    'https://graph.microsoft.com/v1.0/me',
};
